module.exports = __webpack_public_path__ + "static/media/left2.8e1d9060.png";